/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Flex,
  FormControl,
  Checkbox,
  FormLabel,
} from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useLookupCashCenters,
  useLookupDesignations,
  useLookupNationalities,
} from "../../services/lookups-queries";
import FormInput from "../../components/forms/form-Input";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import FormHookDatePicker from "../../components/forms/form-hook-date-picker";
import {
  useLookupAssignmentGroup,
  useLookupBusinessUnits,
  useLookupCities,
  useLookupClients,
  useLookupEmirates,
  useLookupOffices,
  useLookupRegions,
} from "../../services/lookups-mutations";
import {
  useCreateUser,
  useEditUser,
  useGetRolesListQuery,
  useGetUserDetails,
  useVerifyEmployeeId,
} from "../../services/auth-api";
import {
  accountStatus,
  accountTypes,
  editUserFormValued,
  formDefaultValues,
  staffTypes,
} from "./constants";
import Swal from "sweetalert2";

export default function AddUser() {
  const [roles, setRoles] = useState([]);
  const [assignmentGroups, setAssignmentGroups] = useState([]);
  const [existingId, setExistingId] = useState(null);

  const navigate = useNavigate();
  const params = useParams();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    data: createUserData,
    isPending: creatingRequest,
    error: createError,
  } = useCreateUser();
  const {
    mutate: editUserRequest,
    isSuccess: isUserEdited,
    isPending: editingUserRequest,
  } = useEditUser();
  const {
    data: cashCenterListRes,
    isPending: gettingCashCenterList,
    error: cashCenterError,
  } = useLookupCashCenters();
  const {
    mutate: getAssignmentGroup,
    data: assignmentGroupRes,
    isPending: gettingAssignmentGroup,
    error: assignmentGroupError,
    reset: resetAssignmentGroups,
  } = useLookupAssignmentGroup();

  const {
    data: nationalities,
    isPending: gettingNationalities,
    error: nationalitiesError,
  } = useLookupNationalities();
  const {
    data: designations,
    isPending: gettingDesignations,
    error: designationError,
  } = useLookupDesignations();
  const {
    data: rolesList,
    isSuccess: rolesAvailable,
    isPending: gettingRoles,
    error: rolesError,
  } = useGetRolesListQuery();
  const {
    mutate: getOffices,
    data: officesData,
    isPending: gettingOffices,
    error: officesError,
    reset: resetOffices,
  } = useLookupOffices();
  const {
    mutate: getRegions,
    data: regionsList,
    isPending: gettingRegions,
  } = useLookupRegions();
  const {
    mutate: getCities,
    data: citiesList,
    isPending: gettingCities,
  } = useLookupCities();
  const {
    mutate: getEmirates,
    data: emiratesList,
    isPending: gettingEmirates,
  } = useLookupEmirates();
  const {
    mutate: getBusinessUnits,
    data: businessUnitsList,
    isPending: gettingBusinessUnits,
  } = useLookupBusinessUnits();
  const {
    mutate: editUser,
    data: userData,
    isPending: gettingUser,
    error: userError,
    reset: resetUser,
  } = useGetUserDetails();
  const {
    mutate: getClients,
    data: clientsList,
    isPending: gettingClient,
  } = useLookupClients();
  const {
    mutate: verifyEmployeeId,
    data: employeeIdVerificationRes,
    isPending: verifyingEmployeeId,
    reset: resetVerifyEmployeeId,
  } = useVerifyEmployeeId();
  const {
    handleSubmit,
    setValue,
    control,
    getValues,
    reset,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { ...formDefaultValues },
  });

  const formValidationRules = {
    employeeId: {
      required: "Please Enter Employee Id",
      pattern: {
        value: /^[A-Za-z0-9\s]+$/,
        message: "Invalid Pattern(Only Alphanumeric Allowed)",
      },
      validate: (value) => {
        if (employeeIdVerificationRes && existingId && existingId === value) {
          return "User Already Exist. Please Enter  Different Employee Id";
        }
        resetVerifyEmployeeId();
        return true;
      },
    },
    assignment: { required: "Please Select Assignment" },
    userName: { required: "Please Enter User Name" },

    firstName: {
      required: "Please Enter First Name",
      pattern: {
        value: /^[A-Za-z\s]+$/,
        message: "Invalid Pattern(Only Alphabets Allowed)",
      },
    },
    lastName: {
      required: "Please Enter Last Name",
      pattern: {
        value: /^[A-Za-z\s]+$/,
        message: "Invalid Pattern(Only Alphabets Allowed)",
      },
    },
    nationality: { required: "Please Enter Nationality" },
    email: {
      required: "Please Enter Email",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid Email(abc@example.com)",
      },
      // validate: (value) => {
      //   if (
      //     getValues("personalEmail") &&
      //     value !== getValues("personalEmail")
      //   ) {
      //     return "Email Address Does Not Match";
      //   }
      //   return true;
      // },
    },
    personalEmail: {
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid Email(abc@gmail.com)",
      },
      // validate: (value) => {
      //   if (value && value !== getValues("email")) {
      //     return "Email Address Does Not Match";
      //   }
      //   return true;
      // },
    },

    accountType: {
      required: "Please Select Account Type",
      validate: (value) => {
        const formValues = getValues();
        if (value?.id === "Internal") {
          if (!formValues.cashCenter && !formValues.office) {
            return "Please Select Cash Center & Office";
          } else if (!formValues.cashCenter) {
            return "Please Select Cash Center";
          } else if (!formValues.office) {
            return "Please Select Office";
          }
          if (errors.cashCenter) {
            clearErrors("cashCenter");
          }
          return true;
        }
        return true;
      },
    },
    mobileNumber: { required: "Please Enter Mobile Number" },
    accountStatus: { required: "Please Select Account Status" },
    designation: { required: "Please Select Designation" },

    nationalId: {
      pattern: {
        value: /[a-zA-Z0-9\s]+/,
        message: "Invalid Pattern(Only Alphanumeric Allowed)",
      },
    },
    cashCenter: {
      validate: (value) => {
        const formValues = getValues();
        if (formValues.accountType?.id === "Internal" && !value) {
          return "Cash Center Is Required If Account Type Is Internal";
        }
        return true;
      },
    },
    office: {
      validate: (value) => {
        const formValues = getValues();
        if (formValues.accountType?.id === "Internal" && !value) {
          return "Office Is Required If Account Type Is Internal";
        }
        if (formValues.cashCenter && !value) {
          return "Office Is Required If Cash Center Is Selected";
        }

        return true;
      },
    },
    passportNumber: {
      pattern: {
        value: /[a-zA-Z0-9\s]+/,
        message: "Invalid Pattern(Only Alphanumeric Allowed)",
      },
    },
    clientId: {
      validate: (value, formValues) => {
        if (
          formValues.accountType?.id === "External" &&
          (!value || value?.clientId === "0")
        ) {
          return "Client Id Is Required If Account Type Is External";
        }
        return true;
      },
    },
    roles: {
      validate: () => {
        if (getValues("roles").length === 0) {
          return "Please Select Role";
        }
        return true;
      },
    },
  };

  const generalFieldProps = { errors, control };
  const {
    fields: rolesFields,
    remove: removeRole,
    append: appendRole,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "roles",
  });

  useEffect(() => {
    if (params.userId) {
      editUser(params.userId);
    }
    getEmirates("UAE");
    getRegions("UAE");
    getCities("UAE");
    getBusinessUnits();
    getAssignmentGroup();
    getClients();
  }, []);
  useEffect(() => {
    if (isRequestCreated) {
      if (createUserData?.data?.tempPassword && !getValues("isAzureAd")?.id) {
        Swal.fire({
          icon: "success",
          title: `<h4 style="margin: 0; font-size: 20px">User created successfully!</h4>`,
          html: `
              <div style="text-align: left;">
                
                <div style="font-size: 16px; display: flex; align-items: center; gap: 8px; margin-bottom: 15px;">
                  <span style="white-space: nowrap;">Temporary Password:</span>
                  <input 
                    readonly
                    id="tempPassInput" 
                    style="padding: 6px; border: 1px solid #ddd; border-radius: 4px; flex: 1;"
                  value="${createUserData?.data?.tempPassword || ""}"
                    />
                <button id="copyBtn" style="padding: 8px 10px; background: #f31700; color: white; border: none; border-radius: 4px; cursor: pointer; white-space: nowrap; font-size: 14px;">
                  Copy
                </button>
              </div>
              <div style="background: #fff8e1; padding: 4px; border-left: 4px solid #ffc107; margin: 10px 0 0; font-size:12px">
              <p style="margin: 0;"><strong>⚠️ Important:</strong></p>
              <ul style="margin: 5px 0 0 15px; padding-left: 5px; list-style: disc; text-align: left;">
                <li>You must <strong>save this password now</strong> - it won't be shown again</li>
                <li><strong>Share it securely</strong> with the user immediately</li>
                <li>If lost, the user will need to <strong>request a password reset</strong></li>
                <li>Expires on: <strong>${createUserData?.data?.expiryDate?.split("T")[0] || ""}</strong></li>
              </ul>
            </div>
            `,
          didOpen: () => {
            const copyButton = document.getElementById("copyBtn");
            copyButton.addEventListener("click", () => {
              const tempPassInput = document.getElementById("tempPassInput");
              tempPassInput.select();
              document.execCommand("copy");
              // Visual feedback
              copyButton.textContent = "Copied!";
              copyButton.style.background = "#28a745";
              setTimeout(() => {
                copyButton.textContent = "Copy";
                copyButton.style.background = "#f31700";
              }, 1500);
            });
          },
          confirmButtonText: "Close",
          allowOutsideClick: false,
        }).then(() => {
          navigate(Paths.users);
        });
      } else {
        Swal.fire({
          icon: "success",
          title: `<h4 style="margin: 0; font-size: 20px">User created successfully!</h4>`,
          confirmButtonText: "Close",
          allowOutsideClick: false,
        }).then(() => {
          navigate(Paths.users);
        });
      }
      reset();
    }
  }, [isRequestCreated]);

  useEffect(() => {
    if (rolesAvailable) {
      setRoles(rolesList.data);
    }
    if (employeeIdVerificationRes) {
      setError("employeeId", {
        type: "validate",
        message: "User Already Exist. Please Enter  Different Employee Id",
      });
      setExistingId(watch("employeeId"));
    }
    if (isUserEdited) {
      reset();
      navigate(Paths.users);
      return;
    }

    if (
      userData &&
      ((userData.data.cashCenter &&
        userData.data.accountType === "Internal" &&
        officesData) ||
        !userData?.data.cashCenter ||
        userData?.data.accountType !== "Internal") &&
      cashCenterListRes &&
      nationalities &&
      designations &&
      rolesList &&
      clientsList &&
      assignmentGroups.length > 0
    ) {
      populateUserData();
      resetUser();
    }

    if (assignmentGroupRes) {
      setAssignmentGroups(
        assignmentGroupRes.data.map((elm) => ({
          text: elm.name,
          id: elm.name,
        })),
      );
      resetAssignmentGroups();
    }
  }, [
    userData,
    officesData,
    cashCenterListRes,
    nationalities,
    designations,
    rolesList,
    officesData,
    rolesAvailable,
    createError,
    cashCenterError,
    nationalitiesError,
    designationError,
    rolesError,
    officesError,
    userError,
    isUserEdited,
    assignmentGroupError,
    assignmentGroupRes,
    assignmentGroups,
    clientsList,
    employeeIdVerificationRes,
  ]);

  useEffect(() => {
    if (
      userData &&
      userData.data.cashCenterId &&
      userData.data.accountType === "Internal"
    ) {
      getOffices(userData.data.cashCenterId);
    }
  }, [userData]);

  const populateUserData = () => {
    const data = { ...userData.data };

    const _userData = {
      ...data,
      personalMobileNumber: data?.personalMobileNo || "",
    };

    reset(
      editUserFormValued(
        _userData,
        cashCenterListRes.data,
        nationalities.data,
        designations.data,
        rolesList.data,
        officesData?.data || [],
        assignmentGroups,
        clientsList?.data || [],
      ),
    );
  };

  const onSubmit = async (data) => {
    if (employeeIdVerificationRes) {
      setError("employeeId", {
        type: "validate",
        message: "User Already Exist. Please Enter  Different Employee Id",
      });
      return;
    }

    const _payload = {
      employeeId: data.employeeId,
      cenconId: data.cenconId || "",
      firstName: data.firstName,
      lastName: data.lastName,
      userName: data.userName,
      email: data.email,
      mobileNo: data.mobileNumber,
      designation: data.designation?.description,
      assignment: data.assignment?.id || "",
      status: data.accountStatus?.id || "",
      accountType: data.accountType.id,
      staffType: data.staffType.id,
      businessUnit: data.businessUnit.id,
      state: data.state.id ? data.state.id : "",
      city: data.city?.id ? data.city?.id : "",
      emirate: data.emirate?.id ? data.emirate?.id : "",
      managerId: data.managerId ? data.managerId : "",
      cashCenterId: data.cashCenter?.cashCenterId,
      officeId: data.office?.officeId,
      clientId: data.clientId?.clientId || "",
      personalEmail: data.personalEmail ? data.personalEmail : "",
      personalMobileNo: data.personalMobileNumber
        ? data.personalMobileNumber
        : "",
      dateOfBirth: data.dateOfBirth,
      dateOfJoining: data.dateOfJoining,

      nationality: data.nationality?.name,
      nationalId: data.nationalId,
      nationalIdExpiry: data.nationalIdExpiry,
      passportNo: data.passportNumber ? data.passportNumber : "",
      passportExpiry: data.passportExpiry,
      drivingLicenseNo: data.drivingLicenseNo ? data.drivingLicenseNo : "",
      drivingLicenseExpiry: data.drivingExpiry,
      isAzureAd: data.isAzureAd?.id || false,
      roles: data.roles.map((role) => role.name),
    };
    if (params.userId) {
      editUserRequest({
        userName: _payload.userName,
        employeeId: _payload.employeeId,
        firstName: _payload.firstName,
        lastName: _payload.lastName,
        email: _payload.email,
        mobileNo: _payload.mobileNo,
        designation: _payload.designation,
        assignment: _payload.assignment,
        status: _payload.status,
        accountType: _payload.accountType,
        staffType: _payload.staffType,
        businessUnit: _payload.businessUnit,
        managerId: _payload.managerId,
        state: _payload.state,
        city: _payload.city,
        emirate: _payload.emirate,
        cenconId: _payload.cenconId,
        cashCenterId: _payload.cashCenterId,
        officeId: _payload.officeId,
        clientId: _payload.clientId,
        personalEmail: _payload.personalEmail,
        personalMobileNo: _payload.personalMobileNo,
        dateOfBirth: _payload.dateOfBirth,
        dateOfJoining: _payload.dateOfJoining,
        nationality: _payload.nationality,
        nationalId: _payload.nationalId,
        nationalIdExpiry: _payload.nationalIdExpiry,
        passportNo: _payload.passportNo,
        passportExpiry: _payload.passportExpiry,
        drivingLicenseNo: _payload.drivingLicenseNo,
        drivingLicenseExpiry: _payload.drivingLicenseExpiry,
        roles: _payload.roles,
        isAzureAd: data.isAzureAd?.id || false,
      });
      return;
    }

    createRequest(_payload);
  };

  const onCashCentersChanged = (event) => {
    const value = event.target.value;
    if (value.locationId === "0") return;
    getOffices(value.cashCenterId);
  };
  const onRolesChange = (role) => {
    const roleFoundIndex = rolesFields.findIndex(
      (elm) => elm.name === role.name,
    );
    if (roleFoundIndex === -1) {
      appendRole({ name: role.name });
    } else {
      removeRole(roleFoundIndex);
    }
  };

  const onAccountTypeChange = (event) => {
    const value = event.value;
    if (value.id === "External") {
      setValue("cashCenter", null);
      setValue("office", null);
      resetOffices();
    }
    if (value.id === "Internal") {
      setValue("clientId", null);
    }
    setValue("assignment", "");
    clearErrors(["cashCenter", "office", "accountType"]);
  };

  return (
    <>
      {creatingRequest ||
      gettingCashCenterList ||
      editingUserRequest ||
      gettingDesignations ||
      gettingOffices ||
      gettingRoles ||
      gettingRegions ||
      gettingCities ||
      gettingEmirates ||
      gettingBusinessUnits ||
      gettingAssignmentGroup ||
      gettingNationalities ||
      verifyingEmployeeId ||
      gettingClient ||
      gettingUser ||
      (params.userId && !watch("employeeId")) ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Users", link: Paths.users },
            {
              text: params.userId ? "Edit User" : "Create Request",
              isCurrentPage: true,
            },
          ]}
        />

        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="add-location-form"
              >
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Employee Id"
                  name="employeeId"
                  rules={formValidationRules.employeeId}
                  info="Alphanumeric Only"
                  onBlur={() => {
                    if (!params.userId) verifyEmployeeId(watch("employeeId"));
                  }}
                  onChange={() => {
                    clearErrors(["employeeId"]);
                    resetVerifyEmployeeId();
                  }}
                />

                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="User Name"
                  name="userName"
                  rules={formValidationRules.userName}
                />

                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Account Type"
                  name="accountType"
                  id="id"
                  text="text"
                  placeholder="Select Account Type"
                  data={accountTypes || []}
                  rules={formValidationRules.accountType}
                  filterable={false}
                  onChange={onAccountTypeChange}
                />

                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Account Status"
                  name="accountStatus"
                  id="id"
                  text="text"
                  placeholder="Select Account Status"
                  data={accountStatus || []}
                  rules={formValidationRules.accountStatus}
                  filterable={false}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="AD User"
                  name="isAzureAd"
                  id="id"
                  text="text"
                  placeholder="Select User Type"
                  data={[
                    { text: "Yes", id: true },
                    { text: "No", id: false },
                  ]}
                  filterable={false}
                />

                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="First Name"
                  name="firstName"
                  rules={formValidationRules.firstName}
                  info="Alphabets Only"
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Last Name"
                  name="lastName"
                  rules={formValidationRules.lastName}
                  info="Alphabets Only"
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Nationalities"
                  name="nationality"
                  id="code"
                  text="name"
                  placeholder="Select Nationality"
                  data={nationalities?.data || []}
                  rules={formValidationRules.nationality}
                  filterable
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Email"
                  name="email"
                  rules={formValidationRules.email}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired={false}
                  label="Personal Email"
                  name="personalEmail"
                  rules={formValidationRules.personalEmail}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Mobile No"
                  name="mobileNumber"
                  rules={formValidationRules.mobileNumber}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired={false}
                  label="Personal Mobile No"
                  name="personalMobileNumber"
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Designation"
                  name="designation"
                  id="description"
                  text="description"
                  placeholder="Select Designation"
                  data={designations?.data || []}
                  rules={formValidationRules.designation}
                  filterable
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Assignment"
                  name="assignment"
                  id="id"
                  text="text"
                  placeholder="Select Assignment"
                  data={
                    assignmentGroups?.filter((elm) => {
                      const isExternal =
                        watch("accountType")?.id === "External";
                      return isExternal
                        ? elm.text === "Customer"
                        : elm.text !== "Customer";
                    }) || []
                  }
                  rules={formValidationRules.assignment}
                  filterable={false}
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Date of Birth"
                  name="dateOfBirth"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Date of Joining"
                  name="dateOfJoining"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="National Id"
                  name="nationalId"
                  rules={formValidationRules.nationalId}
                  info="Only Alphanumeric Allowed"
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="National Id Expiry"
                  name="nationalIdExpiry"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired={false}
                  label="Passport No"
                  name="passportNumber"
                  rules={formValidationRules.passportNumber}
                  info="Only Alphanumeric Allowed"
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Passport Expiry"
                  name="passportExpiry"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Driving License No"
                  name="drivingLicenseNo"
                />
                <FormHookDatePicker
                  {...generalFieldProps}
                  label="Driving Expiry"
                  name="drivingExpiry"
                  datePickerProps={{ placeholder: "Select Date" }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Cash Center"
                  name="cashCenter"
                  id="locationId"
                  text="name"
                  disabled={watch("accountType")?.id !== "Internal"}
                  isRequired={watch("accountType")?.id === "Internal"}
                  data={cashCenterListRes?.data || []}
                  placeholder="Select Cash Center"
                  dropdownProps={{ filterable: false }}
                  rules={formValidationRules.cashCenter}
                  onChange={onCashCentersChanged}
                  info={
                    watch("accountType")?.id === "Internal"
                      ? ""
                      : "Applicable For Internal Account Type"
                  }
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Office"
                  name="office"
                  id="officeId"
                  text="officeName"
                  disabled={
                    !(
                      watch("accountType")?.id === "Internal" &&
                      watch("cashCenter")
                    )
                  }
                  isRequired={watch("accountType")?.id === "Internal"}
                  data={officesData?.data || []}
                  placeholder="Select Office"
                  rules={formValidationRules.office}
                  dropdownProps={{ filterable: false }}
                  info={
                    watch("accountType")?.id !== "Internal"
                      ? "Applicable For Internal Account Type"
                      : !watch("cashCenter")
                        ? "Select Cash Center"
                        : ""
                  }
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  disabled={watch("accountType")?.id === "Internal"}
                  isRequired={watch("accountType")?.id === "External"}
                  id="clientId"
                  text="name"
                  data={
                    clientsList?.data.map((elm) => ({
                      ...elm,
                      name: `${elm.name} (${elm.type})`,
                    })) || []
                  }
                  label="Client Id"
                  name="clientId"
                  rules={formValidationRules.clientId}
                  placeholder="Select Client"
                  dropdownProps={{ filterable: false }}
                  info={
                    watch("accountType")?.id === "External"
                      ? ""
                      : "Applicable For External Account Type"
                  }
                />
                <FormInput
                  {...generalFieldProps}
                  label="Cencon Id"
                  name="cenconId"
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Staff Type"
                  name="staffType"
                  id="id"
                  text="text"
                  data={staffTypes || []}
                  placeholder="Select Staff Type"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Business Unit"
                  name="businessUnit"
                  id="id"
                  text="text"
                  data={
                    businessUnitsList?.data.map((elm) => ({
                      id: elm.name,
                      text: elm.name,
                    })) || []
                  }
                  placeholder="Select Business Unit"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="City"
                  name="city"
                  id="id"
                  text="text"
                  data={
                    citiesList?.data.map((elm) => ({
                      id: elm.name,
                      text: elm.name,
                    })) || []
                  }
                  placeholder="Select City"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="State"
                  name="state"
                  id="id"
                  text="text"
                  data={
                    regionsList?.data.map((elm) => ({
                      id: elm.name,
                      text: elm.name,
                    })) || []
                  }
                  placeholder="Select Regions"
                  dropdownProps={{ filterable: false }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  label="Emirate"
                  name="emirate"
                  id="id"
                  text="text"
                  data={
                    emiratesList?.data.map((elm) => ({
                      id: elm.name,
                      text: elm.name,
                    })) || []
                  }
                  placeholder="Select Emirates"
                  dropdownProps={{ filterable: false }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Manager Id"
                  name="managerId"
                />
                <FormControl style={{ width: "100%" }} isRequired>
                  <Controller
                    control={control}
                    name="roles"
                    rules={formValidationRules.roles}
                    render={() => {
                      return <FormLabel>Select Roles</FormLabel>;
                    }}
                  />

                  {errors.roles ? (
                    <p className="error-message">Please Select Roles</p>
                  ) : (
                    <></>
                  )}
                </FormControl>
                {roles.map((role, index) => {
                  return (
                    <FormControl key={`${role.name}-${index}`}>
                      <Checkbox
                        isChecked={
                          rolesFields.findIndex(
                            (elm) => elm.name === role.name,
                          ) !== -1
                        }
                        name={role.name}
                        id={role.name}
                        onChange={() => onRolesChange(role)}
                      >
                        <FormLabel
                          style={{ marginBottom: 0 }}
                          htmlFor={role.name}
                        >
                          {role.name}
                        </FormLabel>
                      </Checkbox>
                    </FormControl>
                  );
                })}
                <Flex
                  w="100%"
                  justify="flex-end"
                  flexDirection="row"
                  disabled={verifyingEmployeeId}
                >
                  <Button type="submit">Submit</Button>
                </Flex>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
